// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// locales
import ThemeLocalization from './locales';
// components
import { ConfirmationDialogProvider } from '@utils/contexts/ConfirmationDialog';
import { MotionLazyContainer } from './components/animate';
import { ThemeSettings } from './components/settings';
import SnackbarProvider from './components/snackbar';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <ThemeLocalization>
            <ConfirmationDialogProvider>
              <SnackbarProvider>
                <Router />
              </SnackbarProvider>
            </ConfirmationDialogProvider>
          </ThemeLocalization>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
